module.exports = __webpack_public_path__ + "static/media/abbott.ed3ee264.png";